import { Timestamp } from '@angular/fire/firestore';
// import { OutputData } from '@editorjs/editorjs';
import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { GradeLesson } from '../../models/grade-lesson.school.model';

export const getGradeLessons = createAction(
  '[School GradeLesson] Get gradeLessons',
  props<{
    groupId: string;
    gradeId: string;
    academicYear: number;
    status: string[];
    publishBy?: boolean;
    lastRecord?: Timestamp;
  }>(),
);

export const addGradeLessonsToStore = createAction(
  '[School GradeLesson] Add gradeLessons to store',
  props<{ lessons: GradeLesson[] }>(),
);
export const addGradeLessonToStore = createAction(
  '[School GradeLesson] Add gradeLesson to store',
  props<{ lesson: GradeLesson }>(),
);

export const getGradeLessonsFailure = createAction(
  '[School GradeLesson] Get gradeLessons Failed',
  props<{ error: AppExceptionModel }>(),
);

export const getGradeLesson = createAction(
  '[School GradeLesson] Get gradegradeLesson',
  props<{ groupId: string; gradeLessonId: string }>(),
);

export const getGradeLessonFailure = createAction(
  '[School GradeLesson] Get gradegradeLesson failure',
  props<{ error: AppExceptionModel }>(),
);

// Create gradeLesson Actions
export const create = createAction(
  '[School GradeLesson] Create',
  props<{ groupId: string; lessonId: string; gradeLesson: GradeLesson }>(),
);
export const createFailure = createAction(
  '[School GradeLesson] Create Failure',
  props<{ error: AppExceptionModel }>(),
);
export const createSuccess = createAction(
  '[School GradeLesson] Create Success',
  props<{ lesson: GradeLesson }>(),
);

// Update gradeLesson Actions
export const update = createAction(
  '[School GradeLesson] Update',
  props<{
    groupId: string;
    lessonId: string;
    gradeLesson: GradeLesson;
  }>(),
);
export const updateFailure = createAction(
  '[School GradeLesson] Update Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction(
  '[School GradeLesson] Update Success',
  props<{ lesson: GradeLesson }>(),
);

// Update gradeLesson Notes
export const updateNotes = createAction(
  '[School GradeLesson] Update Notes',
  props<{
    groupId: string;
    lessonId: string;
    // notesData: OutputData;
  }>(),
);
export const updateNotesFailure = createAction(
  '[School GradeLesson] Update Notes Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateNotesSuccess = createAction(
  '[School GradeLesson] Update Notes Success',
  props<{ lesson: GradeLesson }>(),
);

// Delete gradeLesson Actions
export const deleteAction = createAction(
  '[School GradeLesson] Delete',
  props<{ groupId: string; id: string }>(),
);
export const deleteFailure = createAction(
  '[School GradeLesson] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[School GradeLesson] Delete success',
  props<{ id: string }>(),
);

export const deleteFromStore = createAction(
  '[School GradeLesson] Clear from store',
  props<{ id: string }>(),
);

export const loadGradeLessonStats = createAction(
  '[School GradeLesson] Load GradeLessons Stats',
  props<{ groupId: string }>(),
);

export const clear = createAction('[School GradeLesson] Clear GradeLessons');

export const clearFromStore = createAction(
  '[School GradeLesson] Clear multiple from store',
  props<{ ids: string[] }>(),
);

export const clearByAcademicYear = createAction(
  '[School GradeLesson] Clear GradeLessons By Academic Year',
  props<{ groupId: string; academicYear: number }>(),
);
